import { Content, Portal } from '@radix-ui/react-popover'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

export type PopoverContentProps = ComponentPropsWithoutRef<typeof Content>

export const PopoverContent = forwardRef<
  ElementRef<typeof Content>,
  ComponentPropsWithoutRef<typeof Content>
>(
  (
    {
      className,
      align = 'center',
      sideOffset = 4,
      collisionPadding = 4,
      ...props
    },
    ref
  ) => (
    <Portal>
      <Content
        data-slot="popover-content"
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-portal w-72 rounded-md border border-zinc-200 bg-white p-4 text-zinc-950 shadow-md outline-hidden data-[state=closed]:animate-out data-[state=open]:animate-in dark:border-zinc-800 dark:bg-zinc-950 dark:text-zinc-50',
          className
        )}
        // onWheel stop propagation to enable scrolling in popovers in dialogs
        // https://github.com/radix-ui/primitives/issues/1159#issuecomment-1741282769 (you may need to 'load more' on the page to see the comment on the issue)
        onWheel={(e) => e.stopPropagation()}
        onTouchMove={(e) => e.stopPropagation()}
        {...props}
      />
    </Portal>
  )
)
PopoverContent.displayName = Content.displayName
